import { ToastSize, ToastType } from './Toast.types';
import { IconName, IconSize, TypoVariant } from '@/components';

export const ICON_SIZES = {
  [ToastSize.XXS]: IconSize.XS,
  [ToastSize.XS]: IconSize.S,
  [ToastSize.S]: IconSize.M,
  [ToastSize.M]: IconSize.L,
  [ToastSize.L]: IconSize.L,
  [ToastSize.XL]: IconSize.XL,
  [ToastSize.XXL]: IconSize.XL,
};

export const ICON_NAMES = {
  [ToastType.Success]: IconName.Success,
  [ToastType.Warning]: IconName.AlertTriangle,
  [ToastType.Error]: IconName.CriticalError,
  [ToastType.CriticalError]: IconName.CriticalError,
  [ToastType.Info]: IconName.Info,
  [ToastType.ImportantInfo]: IconName.Info,
  [ToastType.NeutralInfo]: IconName.Info,
  [ToastType.White]: IconName.Info,
};

export const TITLE_VARIANTS = {
  [ToastSize.XXS]: TypoVariant.CaptionMBold,
  [ToastSize.XS]: TypoVariant.BodySBold,
  [ToastSize.S]: TypoVariant.BodyMBold,
  [ToastSize.M]: TypoVariant.BodyLBold,
  [ToastSize.L]: TypoVariant.BodyXLBold,
  [ToastSize.XL]: TypoVariant.Heading5,
  [ToastSize.XXL]: TypoVariant.Heading3,
};

export const DESCRIPTION_VARIANTS = {
  [ToastSize.XXS]: TypoVariant.CaptionSRegular,
  [ToastSize.XS]: TypoVariant.BodyXSRegular,
  [ToastSize.S]: TypoVariant.BodySRegular,
  [ToastSize.M]: TypoVariant.BodyMRegular,
  [ToastSize.L]: TypoVariant.BodyMRegular,
  [ToastSize.XL]: TypoVariant.BodyLRegular,
  [ToastSize.XXL]: TypoVariant.BodyXLRegular,
};
